const ar = {
  language: {
    label: "اللغة",
    english: "الإنجليزية",
    arabic: "العربية",
  },
  common: {
    logout: "تسجيل الخروج",
    orders: "طلبات",
  },
  vendor: {
    menu: {
      vendorDashboard: "لوحة تحكم المندوب",
      users: "المستخدمون",
      drivers: "السائقون",
      vendorOrders: "طلبات المندوب",
      configuration: "الإعدادات",
      vendorConfiguration: "إعدادات المندوب",
      pricing: "التسعير",
      godsEye: "الرؤية الشاملة",
    },
    dashboard: {
      overviewTitle: "نظرة عامة على لوحة تحكم المندوب",
      deliveryPerformance: "أداء التوصيل",
      topMerchants: "أفضل 5 تجار",
      orderStatusOverview: "نظرة عامة على حالة الطلبات",
      logisticsMovement: "حركة الخدمات اللوجستية",
      movements: "الحركات",
      orders: "الطلبات",
      confirmed: "تم التأكيد",
      pickedUp: "تم الاستلام",
      onDelivery: "قيد التوصيل",
      delivered: "تم التسليم",
      cancelled: "تم الإلغاء",
      returned: "تم الإرجاع",
      failed: "فشل",
      arrived: "وصل",
      departed: "غادر",
      inTransit: "في الطريق",
      merchantA: "التاجر أ",
      merchantB: "التاجر ب",
      merchantC: "التاجر ج",
      merchantD: "التاجر د",
      merchantE: "التاجر هـ",
    },
    kpi: {
      drivers: "السائقون",
      totalOrders: "إجمالي الطلبات",
      returnedOrders: "الطلبات المرتجعة",
      totalCollected: "إجمالي المحصل",
      codFee: "رسوم الدفع عند الاستلام",
      vendorPayable: "المستحق للمندوب",
      pending: "قيد الانتظار",
      confirmed: "تم التأكيد",
      pickedUp: "تم الاستلام",
      onDelivery: "قيد التوصيل",
      delivered: "تم التسليم",
      cancelled: "تم الإلغاء",
      returnRequested: "تم طلب الإرجاع",
      returnAssigned: "تم تعيين الإرجاع",
      returnPickedUp: "تم استلام الإرجاع",
      returnOnDelivery: "إرجاع قيد التوصيل",
      returned: "تم الإرجاع",
    },
  },
};

export default ar;
